import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { collection, doc, setDoc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authInitialized, setAuthInitialized] = useState(false);
  const [userDocumentId, setUserDocumentId] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log('Auth state changed:', user ? `User logged in: ${user.uid}` : 'User logged out');


      
      setUser(user);
      setLoading(false);
      setAuthInitialized(true);
      
      // Simple localStorage handling
      if (user) {
        localStorage.setItem('rag_user_id', user.uid);
      } else {
        localStorage.removeItem('rag_user_id');
      }
    });

    return unsubscribe;
  }, []);

  const value = {
    user,
    loading,
    authInitialized
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export { AuthContext };